import { AudienceConstants } from 'types/api/audience/enums';

export const MiscellaneousFormFieldsName = 'Misc';

class CategoryMapper {
  map(from: string): string {
    switch (from) {
      case MiscellaneousFormFieldsName:
        return AudienceConstants.RFM;

      default:
        return from;
    }
  }

  reverse(from: string): string {
    switch (from) {
      case AudienceConstants.RFM:
        return MiscellaneousFormFieldsName;

      default:
        return from;
    }
  }
}

export const categoryMapper = new CategoryMapper();
